import { useCallback } from 'react'
import * as R from 'ramda'

import type { Estimate, Order } from '~/types'

interface UseEstimateIsCheckedItemProps {
  estimate: Estimate
}

export const useEstimateIsCheckedItem = ({
  estimate,
}: UseEstimateIsCheckedItemProps) => {
  const groups = estimate?.groups || []
  const group = groups[0] // Estimates have single group
  const items = group?.groupedItems || []

  return useCallback(
    (item: Order): boolean =>
      // Check if item is already in estimate (fully added)
      items.some((candidate) => {
        if (!R.isNil(candidate.items)) {
          return candidate.items?.some(
            (it) => it.logType === item.type && it.name === item.name,
          )
        }
        return candidate.logType === item.type && candidate.name === item.name
      }),
    [items],
  )
}
